'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bulldozer';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e655';
var svgPathData = ['M48 400c0 53 43 96 96 96l224 0c53 0 96-43 96-96s-43-96-96-96l-224 0c-53 0-96 43-96 96zM80 208l0 100.1c18.1-12.7 40.2-20.1 64-20.1l224 0c23.8 0 45.9 7.4 64 20.1l0-52.1c0-26.5-21.5-48-48-48L80 208zm80 192a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm112 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm112 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M257.7 67.4l62.3 124.6 48 0 0-88c0-4.4 3.6-8 8-8s8 3.6 8 8l0 88c35.3 0 64 28.7 64 64l0 56 96 0 0-112c0-39.8 32.2-72 72-72l16 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-16 0c-30.9 0-56 25.1-56 56l0 240c0 30.9 25.1 56 56 56l16 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-16 0c-39.8 0-72-32.2-72-72l0-112-90.2 0c16.4 19.5 26.2 44.6 26.2 72 0 61.9-50.1 112-112 112l-224 0c-61.9 0-112-50.1-112-112 0-30.5 12.2-58.2 32-78.4L64 96c0-35.3 28.7-64 64-64l72.4 0c24.2 0 46.4 13.7 57.2 35.4zM376 208l-296 0 0 100.1c18.1-12.7 40.2-20.1 64-20.1l224 0c23.8 0 45.9 7.4 64 20.1l0-52.1c0-26.5-21.5-48-48-48l-8 0zM243.4 74.5C235.2 58.3 218.6 48 200.4 48L128 48c-26.5 0-48 21.5-48 48l0 96 222.1 0-58.7-117.5zM144 304c-53 0-96 43-96 96s43 96 96 96l224 0c53 0 96-43 96-96s-43-96-96-96l-224 0zm208 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBulldozer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;